import Icon from "../../../components/iconMaster";
import { Link, useLocation } from "react-router-dom";
import CommonModal from "../../../components/modal/CommonModal";
import { lazy, startTransition, useEffect, useState } from "react";
import InputField from "../../../components/input";
import { useAddDispatch, useAppSelector } from "../../../store";
import { logout } from "../../../auth/userSlice";
import Icons from "../../../components/iconMaster/Icons";
import GlobalSearch from "../../globalSearch";
const DestinationHeader = lazy(() => import("./destinations"));
const PackagesHeader = lazy(() => import("./Packages"));
const Login = lazy(() => import("../../agent/login"));

export default function Header({
    showLogin,
    setShowLogin,
    globalSearchPopup,
    setGlobalSearchPopup
}: any) {
    const location = useLocation();
    const dispatch = useAddDispatch();
    const { user, isLoggedIn } = useAppSelector((state) => state.userSlice);
    const [hasLoggedOut, setHasLoggedOut] = useState(false);

    const handleLogout = () => {
        dispatch(logout());
        setHasLoggedOut(true);
    }
    useEffect(() => {
        let timeoutId: any;
        if (location.pathname !== "/") return;

        if (!isLoggedIn && !hasLoggedOut) {
            timeoutId = setTimeout(() => {
                setShowLogin(true);
            }, 10000); // 10 seconds
        }

        return () => clearTimeout(timeoutId); // Cleanup to prevent memory leaks or showing when user logs in
    }, [isLoggedIn, hasLoggedOut]);

    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [submenuOpen, setSubmenuOpen] = useState<string | null>(null);

    // Detect screen size
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 992);
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const openMenu = () => setIsMenuOpen(true);

    const closeMenu = (event?: React.MouseEvent) => {
        if (event) event.stopPropagation();
        setIsMenuOpen(false);
        setSubmenuOpen(null);
    };

    const openSubmenu = (name: string) => setSubmenuOpen(name);
    const backToMainMenu = () => setSubmenuOpen(null);



    return (
        <>
            <header id="header" className="bg-white header sticky-top" >
                <div className="container">

                    <nav className="navbar d-flex align-items justify-content-between">
                        <Link className="navbar-brand" to="/">
                            <img loading="lazy" width={90} src="../../../assets/images/logo.png" alt="" />
                            {process.env.REACT_APP_ENV === "QA" && <strong className="text-qa">QA</strong>}
                        </Link>


                        <div className="headerMenu">
                            <ul className="top-menu">
                                <li><a role="button" onClick={() => setGlobalSearchPopup(true)}><i className='bx bx-search'></i> <span>Search</span> </a></li>
                                <li><Link to="/registration"><i className='bx bxs-user-circle'></i> <span>Register</span></Link></li>
                                <li>
                                    <a role="button" className="desktop-item"><i className='bx bx-support'></i> <span>Support</span> <i className="bx bx-chevron-down"></i></a>
                                    <ul className="item inter-regular">

                                        <li>
                                            <div className="d-flex gap-2">
                                                <Icons className="menu-icon" name="international-support" width="18px" height="18px" />
                                                <div className="list-item">
                                                    <h5 className="text-base">International Support</h5>
                                                    <strong>+66 99 441 0149</strong>
                                                    {/* <strong>+66 95 825 0699</strong> */}
                                                    <a role="button">sales.thai@tctdmc.com</a>
                                                </div>
                                            </div>
                                        </li>

                                        <li>
                                            <div className="d-flex gap-2">
                                                <Icons className="menu-icon" name="sales-support" width="18px" height="18px" />
                                                <div className="list-item">
                                                    <h5 className="text-base">You can also call on:</h5>
                                                    <span>India Sales And Support</span>
                                                    <strong>+91 8644 98 6444</strong>
                                                    <a role="button">sales.ind@tctdmc.com</a>
                                                    {/* <a role="button">sales.bom@tctdmc.com</a> */}
                                                </div>
                                            </div>
                                        </li>

                                        <li>
                                            <div className="d-flex gap-2">
                                                <Icons className="menu-icon" name="operating" width="18px" height="18px" />
                                                <div className="list-item">
                                                    <h5 className="text-base">Operating Hour </h5>
                                                    <p>07:00 - 20:00(GMT+7) l Monday - Saturday</p>
                                                </div>
                                            </div>
                                        </li>

                                        <li>
                                            <div className="d-flex gap-2">
                                                <Icons className="menu-icon" name="offices" width="18px" height="18px" />
                                                <div className="list-item">
                                                    <Link to="/contact">Nearest TCTDMC office <i className='bx bx-chevron-right'></i></Link>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </li>

                                {/* <li><a role="button"> <Icons name="flag-in" width="18px" height="18px" /> IND</a></li> */}
                                {isLoggedIn && <li>
                                    <a role="button" className="nav-link" title="User"><i className='bx bx-user'></i> Welcome, {user?.title} {user?.firstName} {user?.lastName}</a>
                                    <ul className="item ropa-sans-regular">
                                        <li>
                                            <div className="d-flex">
                                                <div className="list-item">
                                                    <a
                                                        role="button"
                                                        className="nav-link" title="Logout"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            handleLogout();
                                                        }}
                                                    >Logout</a>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </li>
                                }
                                {!isLoggedIn &&
                                    <li className="nav-item">
                                        <a role="button" className="nav-link"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                startTransition(() => {
                                                    setShowLogin(true);
                                                });
                                            }}
                                        >
                                            <i className='bx bx-user'></i> <span>Login</span>
                                        </a>
                                    </li>
                                }
                            </ul>

                            <button className="btn hamburger" onClick={openMenu}>
                                <i className="fa fa-bars"></i>
                            </button>

                            {isMenuOpen && <div className="menu-overlay" onClick={closeMenu}></div>}
                            <div className={`mobile-menu ${isMenuOpen ? "active" : ""}`}>
                                <ul className={`main-menu ropa-sans-regular ${submenuOpen ? "submenu-active" : ""}`} >

                                    <button className="btn close-btn" onClick={closeMenu}>
                                        <i className="bx bx-x"></i>
                                    </button>

                                    <li>
                                        <Link to="/whatWeDo" onClick={closeMenu}>What We Do</Link>
                                    </li>

                                    <DestinationHeader
                                        isMobile={isMobile}
                                        openSubmenu={openSubmenu}
                                        backToMainMenu={backToMainMenu}
                                        submenuOpen={submenuOpen === "destination"}
                                        closeMenu={closeMenu} // ✅ Passing down function
                                    />

                                    <PackagesHeader
                                        isMobile={isMobile}
                                        openSubmenu={openSubmenu}
                                        backToMainMenu={backToMainMenu}
                                        submenuOpen={submenuOpen === "packages"}
                                        closeMenu={closeMenu} // ✅ Passing down function
                                    />

                                    {/* <li className="menu-with-submenu">
                                        <Link
                                            to={"/destination"}>
                                            Testing menu <span onClick={(e) => {
                                                if (isMobile) {
                                                    e.preventDefault();
                                                    openSubmenu("packages"); // open this submenu
                                                }
                                            }} className="submenu-arrow"><i className="fa fa-angle-down"></i></span>
                                        </Link>

                                        <ul className={`sub-menu mega-menu ${submenuOpen ? "open" : ""}`}>
                                            {isMobile && (
                                                <div className="submenu-header">
                                                    <span className="back-btn" onClick={backToMainMenu}>
                                                        <i className="bx bx-left-arrow-alt"></i> Back
                                                    </span>
                                                    <h4 className="submenu-title">Testing menu</h4>
                                                </div>
                                            )}
                                            <div className="grid l-columns--2-3">
                                                <div className="list-item">
                                                    <h4 className="list-title inter-regular fw-medium">Upcoming Tours</h4>
                                                    <ul className="list-unstyled grid l-columns--1-1">
                                                        <li><a href="#" onClick={closeMenu}>Ayutthaya</a></li>
                                                        <li><a href="#" onClick={closeMenu}>Bangkok</a></li>
                                                        <li><a href="#">Chiang Mai</a></li>
                                                        <li><a href="#">Kanchanaburi</a></li>
                                                        <li><a href="#">Koh Kood</a></li>
                                                        <li><a href="#">Koh Yao Noi</a></li>
                                                        <li><a href="#">Krabi</a></li>
                                                        <li><a href="#">Pattaya</a></li>
                                                        <li><a href="#">Phuket</a></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </ul>
                                    </li> */}

                                    {/* Other Main Menu Items */}
                                    <li><Link to="/groupweddings" onClick={closeMenu}>Groups & Weddings</Link></li>
                                    <li><Link to="/bookManage" onClick={closeMenu}>Book & Manage</Link></li>
                                    <li><Link to="/" onClick={closeMenu}>Trending Tours</Link></li>
                                    <li><Link to="/blogs" onClick={closeMenu}>Blogs</Link></li>
                                </ul>


                            </div>

                        </div>
                    </nav>
                </div>

            </header>

            <Login
                showLogin={showLogin}
                setShowLogin={setShowLogin}
            />
            {/* Global Search */}
            {globalSearchPopup &&
                <GlobalSearch
                    globalSearchPopup={globalSearchPopup}
                    setGlobalSearchPopup={setGlobalSearchPopup} />
            }
        </>
    )
}
